import { useState } from "react";
import { cardImage, STARTER_LINES } from "../../../shared/milestones";
import { useI18n } from "../../i18n/I18nProvider";

const GENERATIONS = [...new Set(STARTER_LINES.map((l) => l.gen))];

/** Starter choice: the three starters of each generation, shown with their level 1 card. */
export function StarterPicker({ current, onPick }: { current?: string | null; onPick: (key: string) => Promise<void> }) {
  const { t } = useI18n();
  const [busy, setBusy] = useState<string | null>(null);
  const [error, setError] = useState(false);

  const pick = async (key: string) => {
    setBusy(key);
    setError(false);
    try {
      await onPick(key);
    } catch {
      setError(true);
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="starter-picker">
      {error && <p className="form-error">{t("cards.pickError")}</p>}
      {GENERATIONS.map((gen) => (
        <section key={gen} aria-label={t("cards.generation", { gen })}>
          <h3 className="starter-gen">{t("cards.generation", { gen })}</h3>
          <ul className="starter-trio">
            {STARTER_LINES.filter((l) => l.gen === gen).map((line) => (
              <li key={line.key}>
                <button
                  type="button"
                  className={line.key === current ? "starter-option is-current" : `starter-option is-${line.element}`}
                  aria-pressed={line.key === current}
                  disabled={busy !== null}
                  onClick={() => pick(line.key)}
                >
                  <img src={cardImage(line.cards[0].id)} alt="" width={120} height={167} loading="lazy" />
                  <span>{busy === line.key ? t("cards.picking") : line.name}</span>
                </button>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
